import React, { Component } from 'react';
import Select from '../Select/Select';
import Icon from '../Icon';

class UsersFilters extends Component {
	render() {
		const {
			changed,
			value,
			selectClicked,
			selectItemClicked,
			select
		} = this.props;

		return (
			<div className="AdminUsers-filters">
				<div className="AdminUsers-field">
					<label className="AdminUsers-label">Role</label>
					<Select
						small
						clicked={selectClicked}
						itemClicked={selectItemClicked}
						placeholder={select.placeholder}
						name={select.name}
						value={select.value}
						showList={select.showList}
						styles={select.styles}
						items={select.options}
					/>
				</div>
				<div className="AdminUsers-filter">
					<label className="AdminUsers-label">Search user</label>
					<input
						className="AdminUsers-search"
						value={value}
						onChange={changed}
					/>
					<Icon icon={'search'} />
				</div>
			</div>
		);
	}
}

export default UsersFilters;
